export const STATUS_BACKGROUND_COLORS = {
  Info: "bg-[color:var(--alias-color-bg-info)]",
  Success: "bg-[color:var(--alias-color-bg-success)]",
  Attention: "bg-[color:var(--alias-color-bg-attention)]",
  Critical: "bg-[color:var(--alias-color-bg-critical)]",
  Neutral: "bg-[color:var(--alias-color-bg-neutral)]",
}

export const STATUS_ICON_COLORS = {
  Info: "text-[color:var(--alias-color-icon-info)]",
  Success: "text-[color:var(--alias-color-icon-success)]",
  Attention: "text-[color:var(--alias-color-icon-attention)]",
  Critical: "text-[color:var(--alias-color-icon-critical)]",
  Neutral: "text-[color:var(--alias-color-icon-base)]",
}

export const STATUS_TEXT_COLORS = {
  Info: "text-[color:var(--alias-color-text-on-info)]",
  Success: "text-[color:var(--alias-color-text-on-success)]",
  Attention: "text-[color:var(--alias-color-text-on-attention)]",
  Critical: "text-[color:var(--alias-color-text-on-critical)]",
  Neutral: "text-[color:var(--alias-color-text-on-neutral)]",
}
